import FaceAdd16 from '@carbon/icons-react/es/face--add/16';
import { Popover } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React, { FC, useState } from 'react';
import { Reaction } from 'api/conversations';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';
import { ReactionsList } from './add-reactions-list';
import styles from './add.module.css';

export const Add: FC<
  ButtonProps & {
    addButtonClassName?: string;
    attachTo?: HTMLElement | null;
    onAddReaction(reactionType: Reaction | string): void;
    onReactionVisibilityChange(state: boolean): void;
  }
> = ({
  addButtonClassName,
  attachTo,
  onAddReaction,
  onReactionVisibilityChange,
  ...rest
}) => {
  const [popoverVisibility, setPopoverVisibility] = useState(false);
  const addReactionText = useTranslation('reactions.add');

  const afterAddReaction = (reaction: Reaction) => {
    setPopoverVisibility(false);
    onAddReaction(reaction);
  };

  const handlePopoverVisible = (visibility: boolean) => {
    onReactionVisibilityChange(visibility);
    setPopoverVisibility(visibility);
  };

  return (
    <Popover
      overlayClassName={`${styles.overlay} popover__compact`}
      content={<ReactionsList onAddReaction={afterAddReaction} />}
      trigger="click"
      visible={popoverVisibility}
      getPopupContainer={attachTo ? () => attachTo as HTMLElement : undefined}
      onVisibleChange={handlePopoverVisible}
    >
      <Button
        aria-label={addReactionText}
        className={addButtonClassName}
        icon={<FaceAdd16 />}
        size="small"
        data-cy="chat.message.add_reaction"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
    </Popover>
  );
};
